module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hoelstein-84ae143577e6dbc838121c5e64e54b18.svg";